module.exports = __webpack_public_path__ + "img/photo-projects-taperia.aa899825.png";